import { Button, Stack, Typography } from '@mui/material';
import { ReturnType } from '@zeta-core';
import { TrsanscriptIcon } from '@zeta-core/assets';

interface IFactFindHeading {
  sectionName: string;
  isTranscript?: ReturnType;
  isAllTranscripts?: ReturnType;
  hideButton: boolean;
  hideAllButton?: boolean;
}

const FactFindHeading = ({ isAllTranscripts, isTranscript, sectionName, hideButton, hideAllButton }: IFactFindHeading) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" marginBottom={1.5}>
      <Typography variant="h6" id={sectionName}>
        {sectionName}
      </Typography>
      {!hideAllButton && (
        <Stack flexDirection="row" spacing={1}>
          <Button startIcon={<TrsanscriptIcon />} variant="soft" color="primary" onClick={isAllTranscripts?.onTrue} id="all-transcripts">
            All Transcripts
          </Button>
          {!hideButton && (
            <Button startIcon={<TrsanscriptIcon />} variant="contained" color="primary" onClick={isTranscript?.onTrue} id={`${sectionName}-transcript`}>
              {sectionName} Transcript
            </Button>
          )}
        </Stack>
      )}
    </Stack>
  );
};

export default FactFindHeading;
